import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class PTC_Dashboard {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async retornaDashbord(queries = null) {
    let query = 'ptc/RetornaCardsTotais?';

    if (queries && queries.dataInicial && queries.dataFinal) {
      query += `dataInicial=${queries.dataInicial}&dataFinal=${queries.dataFinal}`;
    }

    if (queries && queries.clienteId) {
      query += query.includes('?') && query.length > query.indexOf('?') + 1 ? '&' : '';
      query += `clienteFinal=${queries.clienteId}`;
    }

    try {
      const result = await this.api.get(query);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar a dashboard');
    }
  }
}
